module.exports = __webpack_public_path__ + "img/gebackenebanane.92156728.jpg";